import ReactDOM from 'react-dom/client';
import analytics from './api/analytics';
import App from './App';

analytics.init();

ReactDOM
	.createRoot(document.getElementById('root')!)
	.render(<App />);
